import { render, staticRenderFns } from "./custom-product-type-1.vue?vue&type=template&id=ad23ff1a&scoped=true&"
import script from "./custom-product-type-1.vue?vue&type=script&lang=js&"
export * from "./custom-product-type-1.vue?vue&type=script&lang=js&"
import style0 from "./custom-product-type-1.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./custom-product-type-1.vue?vue&type=style&index=1&id=ad23ff1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad23ff1a",
  null
  
)

export default component.exports